import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";

var backend = require('../../config.js').backend;

class Popup extends React.Component {

  constructor(props) {
    super(props);

    this.deleteGroup = this.deleteGroup.bind(this);
    this.createGroup = this.createGroup.bind(this);
    this.handleNewGroupName = this.handleNewGroupName.bind(this);
    this.handleNewGroupAdmin = this.handleNewGroupAdmin.bind(this);
    this.handleExistedGroupAdmin = this.handleExistedGroupAdmin.bind(this);

    this.state = {
      newGroup: {
        groupName: '',
        sinAdmin: 0
      },
      groups: [],
      showPopup: false,
      edit: {},
      redirectLogout: false
    };
  }


  componentDidMount() {
    this.getAllDonationGroups()
      .then((result) => {
        // console.log('groups', result)
        this.setState({ groups: result },
          () => {
            this.setState({ editgroups: [...this.state.groups] });
          });
      })

  }


  // Delete Donation Group
  deleteGroup = groupId => {

    var answer = window.confirm("Deleting this group will free all assigned designation. Are you sure you want to delete this donation group ?")

    if (answer) {

      // Delete from the list
      this.setState({ groups: this.deleteGroupFromList(groupId) })
      // Delete from the SQL Database by calling HTTP delete request to api
      this.deleteGroupFromSQL(groupId);

    }

  }

  deleteGroupFromSQL = id => {

    return fetch(backend + 'api/v1/donation/group/' + id, {
      method: 'DELETE',
      credentials: "include"
    })
      .then(res => {
        // console.log(res);
        if (res.redirect) {
          this.setState({ redirectLogout: true })
          window.location.reload(false);
        }
        else {
          NotificationManager.success('Group is deleted successfully');
        }
      })
      .catch(err => err);

  }

  deleteGroupFromList = id => {
    return this.state.groups.filter(group => group.DonationGroupID !== id);
  }


  // Create new donation group
  togglePopup = _ => {
    this.setState({ showPopup: !this.state.showPopup });
  }

  handleNewBankAcc = _ => {
    this.togglePopup();
  }

  handleNewGroupName(event) {

    this.setState({ newGroup: { ...this.state.newGroup, groupName: event.target.value } });

  }

  handleNewGroupAdmin(event) {

    this.setState({ newGroup: { ...this.state.newGroup, sinAdmin: event.target.checked } });

  }

  createGroup = () => {
    var newGroup = this.state.newGroup;
    var name = newGroup.groupName
    var sinAdmin = newGroup.sinAdmin
    if (name !== '') {
      // Add To the SQL Database by calling HTTP post request to api
      this.addGroupToSQL(name, sinAdmin)
        .then(id => {

          // Add to the list
          this.setState({ groups: this.addGroupToList(id, name, sinAdmin) })
          this.togglePopup();

        })
        .catch(err => err);

    }
    else {
      // console.log('no group name entered');
    }

  }

  addGroupToSQL = (name, sinadmin) => {

    var that = this;

    if (sinadmin === true) {
      sinadmin = 1
    }
    else {
      sinadmin = 0
    }

    return new Promise(function (resolve, reject) {
      // Need to change, new group
      return fetch(backend + 'api/v1/donation/group/' + name + '/' + sinadmin, {
        method: 'POST',
        credentials: "include"
      })
        .then(data => data.json())
        .then(data => {
          // console.log(data);
          if (data.redirect) {
            that.setState({ redirectLogout: true })
            window.location.reload(false);
          }
          else {
            var newgroupId = data[0].Id;
            // console.log(newgroupId);
            NotificationManager.success('Group is created successfully!');

            resolve(newgroupId);
          }
        })
        .catch(err => err);

    })

  }

  addGroupToList = (id, name, sinAdmin) => {

    var { groups } = this.state;
    groups.push({
      DonationGroupID: id,
      GroupName: name,
      SinAdmin: sinAdmin
    })

    return groups;
  }


  // Update donation group
  editGroup = (groupId) => {
    // console.log('edit donation group', groupId);
    let edit = this.state;

    edit[groupId] = true;
    // console.log(edit);
    this.setState({ edit: edit });

  }

  disableGroupEdit = (groupId, index) => {
    // console.log('disableGroupEdit', groupId, index);
    let edit = this.state;

    let { editgroups } = this.state;
    var { groups } = this.state;
    var group = groups[index];
    // console.log('original group', group)

    editgroups[index] = group;
    this.setState({ editgroups: editgroups });

    edit[groupId] = false;
    this.setState({ edit: edit });

  }

  // Get all donation groups
  getAllDonationGroups = _ => {

    var that = this;

    return new Promise(function (resolve, reject) {

      fetch(backend + 'api/v1/donation/group/', {
        method: 'GET',
        credentials: "include"
      })
        .then(response => response.json())
        .then((data) => {
          // console.log(data);
          if (data.redirect) {
            that.setState({ redirectLogout: true })
            window.location.reload(false);
          }
          else {
            resolve(data);
          }
        })

    })
  }

  // Update the donation group details
  handleGroupNameChange = (index, event) => {

    // console.log('handleGroupNameChange', index, event.target.value);

    // var {groups} = this.state;
    var { editgroups } = this.state;
    var group = editgroups[index];

    // console.log(editgroups, group);

    group.GroupName = event.target.value;
    editgroups[index] = group;
    this.setState({ editgroups: editgroups },
      () => {
        // console.log(this.state.editgroups, this.state.groups)
      });

  }


  handleExistedGroupAdmin = (index, event) => {
    console.log('handleExistedGroupAdmin', index, event.target.value, event.target.checked);

    // var {groups} = this.state;
    var { editgroups } = this.state;
    var group = editgroups[index];

    // console.log(editgroups, group);

    group.SinAdmin = event.target.checked;
    editgroups[index] = group;
    this.setState({ editgroups: editgroups })

  }


  updateGroup = (groupId, index) => {
    // console.log('updateGroup', groupId, index);

    var { editgroups } = this.state;
    var editgroup = editgroups[index]
    // var {groups} = this.state;
    // var group = groups[index];

    // this.updateGroupAtSQL(groupId, group.GroupName, group.SinAdmin)
    this.updateGroupAtSQL(groupId, editgroup.GroupName, editgroup.SinAdmin)
      .then((data) => {
        // console.log('finish udpating', data);
        this.setState({ groups: editgroups });
        this.disableGroupEdit(groupId, index);
      })
      .catch(err => err);

  }

  updateGroupAtSQL = (groupId, name, sinadmin) => {

    var that = this;

    var url = `api/v1/donation/group/` + groupId + `?name=` + name + `&sinadmin=` + sinadmin;

    // return Promise
    return new Promise(function (resolve, reject) {

      fetch(backend + url, {
        method: 'PUT',
        credentials: "include"
      })
        .then(res => res.json())
        .then(res => {
          if (res.redirect) {
            that.setState({ redirectLogout: true })
            window.location.reload(false);
          }
          else if (res.status === 500) {
            NotificationManager.error('Group' + name + ' cannot be updated!' + res.error);
            reject(res.message)
          }
          else {
            NotificationManager.success('Group' + name + ' is updated successfully!');
            resolve(res)
          }
        })
        .catch(err => err);

    })
  }



  renderSinAdminTick = (group) => {

    if (group.SinAdmin === true) {
      // return (<td><CheckIcon/></td>)
      return (<td>Yes</td>)
    }
    else {
      return (<td></td>)
    }

  }

  renderRow = (group, index) => {

    var row_groupId = group.DonationGroupID;
    var { edit } = this.state;
    var content = '';

    if (!edit[row_groupId]) {
      content = (
        <tr key={row_groupId}>
          <td>{group.GroupName}</td>
          {this.renderSinAdminTick(group)}
          <td className='action'>
            <EditIcon onClick={() => this.editGroup(row_groupId)} />
            <DeleteIcon onClick={() => this.deleteGroup(row_groupId)} />
          </td>
        </tr>
      )
    }

    else {
      var { editgroups } = this.state;
      var editgroup = editgroups[index]
      content = (
        <tr key={row_groupId}>
          <td className='input'>
            <input type="text" value={editgroup.GroupName} onChange={(e) => this.handleGroupNameChange(index, e)} />
          </td>
          <td><Checkbox
            checked={editgroup.SinAdmin}
            value={row_groupId}
            onChange={(e) => this.handleExistedGroupAdmin(index, e)}
            color="primary"
            inputProps={{ 'aria-label': 'primary checkbox' }}
          /></td>
          <td className='action'>
            <DoneIcon onClick={() => this.updateGroup(row_groupId, index)} />
            <ClearIcon onClick={() => this.disableGroupEdit(row_groupId, index)} />
          </td>
        </tr>
      )

    }

    return (content)

  }

  renderGroups = _ => {

    var { groups } = this.state;
    // console.log('renderGroups', groups);

    if (groups.length) {
      return (
        <tbody>
          {groups.map(this.renderRow)}
        </tbody>
      )
    }


  }



  render() {

    let groups_list = this.renderGroups();
    const { redirectLogout } = this.state;

    if (redirectLogout) {
      return (
        <BrowserRouter>
          <Switch>
            <Route exact path="/logout" component={Logout} />
            <Redirect to="/logout" />
          </Switch>
        </BrowserRouter>
      )
    }

    let content = (
      <div className='donation-groups-mgm'>
        <h3>Donation Groups for Sorted Donations Report</h3>

        <div>

          {(this.state.showPopup) ?

            <div>
              <RemoveCircleOutlineIcon onClick={this.handleNewBankAcc} />
              <label>New Donation Group</label>
              <div className='new-group col-md-12 col-sm-12'>
                <div className='row col-md-6 col-sm-6'>
                  <label className='col-md-5 col-sm-5'>New Group Name</label>
                  <div className='input'>
                    <input id="groupname" value={this.state.newGroup.groupName} type="text" name="groupname" onChange={this.handleNewGroupName}></input>
                  </div>

                </div>
                <div className='row col-md-5 col-sm-5'>
                  <label className='col-md-5 col-sm-5'>Sin Admin Charges</label>
                  <div className='checkbox'>
                    <Checkbox
                      checked={this.state.newGroup.checked}
                      onChange={this.handleNewGroupAdmin}
                      color="primary"
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                  </div>
                </div>
                <div className='row col-md-1 col-sm-1'><button className='btn-primary' onClick={() => this.createGroup()}>Confirm</button></div>
              </div>
            </div>
            :
            <div>
              <AddCircleIcon onClick={this.handleNewBankAcc} />
              <label>New Donation Group</label>
            </div>
          }
        </div>


        <div className="donation-groups-table">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th className='group-name'>Group Name</th>
                <th className='sin-admin'>Sin Admin</th>
                <th className='action'>Action</th>
              </tr>
            </thead>
            {groups_list}
          </table>
        </div>

        <NotificationContainer />
      </div>

    )


    return (content);

  }


}


export default Popup;
